import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'abbreviateNumber'
})
export class AbbreviateNumberPipe implements PipeTransform {

  transform(value: string | number, digits = 1): unknown {
    if (!!value) {
      return this.abbreviateNumber(value, digits);
    }

    return value;
  }


  abbreviateNumber(value: string | number, digits = 1): string {
    let containsDollarSign = false;
    let isNegative = false;
    let num;

    if (typeof (value) !== 'number') {
      if (value.includes('$')) {
        containsDollarSign = true;
        num = parseFloat(value.replace('$', '').replace(/,/g, ''));
      } else {
        num = parseFloat(value);
      }
    } else {
      num = value;
    }

    if (num < 0) {
      isNegative = true;
      num = -1 * num;
    }

    const si = [
      {value: 1, symbol: ''},
      {value: 1E3, symbol: 'K'},
      {value: 1E6, symbol: 'M'},
      {value: 1E9, symbol: 'B'},
      {value: 1E12, symbol: 'T'},
      {value: 1E15, symbol: 'P'},
      {value: 1E18, symbol: 'E'}
    ];

    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

    let i;

    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }
    return `${isNegative ? '-' : ''}${containsDollarSign ? '$' : ''}${(num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol}`;
  }
}
